<template>
<a-modal
        :width="modalWidth"
        :visible="visible"
        :title="title"
        destroyOnClose
        :confirmLoading="confirmLoading"
        @ok="handleSubmit"
        @cancel="handleCancel"
        :cancelText="$t('关闭')"
        wrapClassName="ant-modal-cust-warp"
        >
        <template slot="footer">
            <a-button key="close" @click="handleCancel">
                   {{ $t('关闭') }}
            </a-button>
        </template>
    <meter-command-module :queryParentParam="queryParentParam"></meter-command-module>
</a-modal>
</template>

<script>
import meterCommandModule from './meterCommandModule'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
    components: {
        meterCommandModule
    },
    mixins:[JeecgListMixin],
    computed: {
        // i18n：弹窗标题使用 computed 以响应语言切换
        title() {
            return this.$t('命令队列')
        }
    },
    data() {
        return{
            visible: false,
            model: {},
            modalWidth:900,
            confirmLoading: false,
            disableMixinCreated: true,
            queryParentParam: {}
        }
    },
    methods: {
        edit(record) {
            this.queryParentParam.meterId = record.meterId
            this.visible = true;
            this.model = Object.assign({}, record);
        },
        handleCancel() {
            this.close()
        },
        close () {
            this.$emit('close');
            this.visible = false;
        },
        handleSubmit() {
            
        }
    }
}
</script>